import React from 'react';
import {toast} from 'react-toastify';
import qs from 'qs';
import irelandApi from '../irelandApi';
import ToastMessage from '../components/common/toast-message';
import {
  GET_MESSAGES_FULFILLED,
  GET_MESSAGES_PENDING,
  GET_MESSAGES_REJECTED,
  GET_SENT_MESSAGES_FULFILLED,
  GET_SENT_MESSAGES_PENDING,
  GET_SENT_MESSAGES_REJECTED,
  POST_MESSAGES_FULFILLED,
  POST_MESSAGES_PENDING,
  POST_MESSAGES_REJECTED
} from '../reducers/messagesReducer';
import {getMyProfile} from './user';

export const getMessages = read => (dispatch) => {
  dispatch({type: GET_MESSAGES_PENDING});
  const query = {
    read
  };

  return irelandApi.get(`/api/messages?${qs.stringify({q: query}, {encodeValuesOnly: true})}`)
    .then((response) => {
      dispatch({
        type: GET_MESSAGES_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_MESSAGES_REJECTED,
        payLoad: error
      });
    });
};

export const getSentMessages = () => (dispatch) => {
  dispatch({type: GET_SENT_MESSAGES_PENDING});

  return irelandApi.get('/api/messages/my_sent_messages')
    .then((response) => {
      dispatch({
        type: GET_SENT_MESSAGES_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SENT_MESSAGES_REJECTED,
        payLoad: error
      });
    });
};

export const sendMessage = payLoad => (dispatch) => {
  dispatch({type: POST_MESSAGES_PENDING});

  return irelandApi.post('/api/messages', {message: payLoad})
    .then((response) => {
      dispatch({
        type: POST_MESSAGES_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: POST_MESSAGES_REJECTED,
        payLoad: error
      });

      return Promise.reject();
    });
};

export const replyMessage = (messageId, payLoad) => (dispatch) => {
  dispatch({type: POST_MESSAGES_PENDING});

  return irelandApi.post(`/api/messages/${messageId}/reply`, {message: payLoad})
    .then((response) => {
      dispatch({
        type: POST_MESSAGES_FULFILLED,
        payLoad: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: POST_MESSAGES_REJECTED,
        payLoad: error
      });

      return Promise.reject();
    });
};

export const markMessagesAs = (type, ids) => (dispatch) => {
  dispatch({type: 'MARK_MESSAGES_PENDING'});

  return irelandApi.put(`/api/messages/${type}`, {messages: ids})
    .then(() => {
      dispatch({
        type: 'MARK_MESSAGES_FULFILLED',
        payLoad: {
          messageIds: ids,
          read: type === 'read'
        }
      });

      dispatch(getMyProfile('CURRENT_USER_PROFILE'));

      toast.success(<ToastMessage iconStyle="success" message={`Messages has been marked as ${type}`}/>);
    })
    .catch((error) => {
      dispatch({
        type: 'MARK_MESSAGES_REJECTED',
        payLoad: error
      });

      toast.error(<ToastMessage iconStyle="error" message={`An error occurred during marking messages as ${type}`}/>);
      return Promise.reject(error.response.data);
    });
};

export const deleteMessage = (id, type) => (dispatch) => {
  dispatch({type: 'DELETE_MESSAGES_PENDING'});

  return irelandApi.delete(`/api/messages/${id}`)
    .then(() => {
      dispatch({
        type: 'DELETE_MESSAGES_FULFILLED',
        payLoad: {
          messageIds: [id],
          type
        }
      });

      dispatch(getMyProfile('CURRENT_USER_PROFILE'));

      toast.success(<ToastMessage iconStyle="success" message={'Message has been successfully deleted'}/>);
    })
    .catch((error) => {
      dispatch({
        type: 'DELETE_MESSAGES_REJECTED',
        payLoad: error
      });

      toast.error(<ToastMessage iconStyle="error" message={'An error occurred during deleting message'}/>);
      return Promise.reject(error.response.data);
    });
};

export const deleteMessages = ids => (dispatch) => {
  dispatch({type: 'DELETE_MESSAGES_PENDING'});

  return irelandApi.delete('/api/messages_delete/', {data: {messages: ids}})
    .then(() => {
      dispatch({
        type: 'DELETE_MESSAGES_FULFILLED',
        payLoad: {messageIds: ids}
      });

      toast.success(<ToastMessage iconStyle="success" message={'Messages has been successfully deleted'}/>);
    })
    .catch((error) => {
      dispatch({
        type: 'DELETE_MESSAGES_REJECTED',
        payLoad: error
      });

      toast.error(<ToastMessage iconStyle="error" message={'An error occurred during deleting messages'}/>);
      return Promise.reject(error.response.data);
    });
};

export const sendStoreMessage = message => (dispatch) => {
  dispatch({type: 'POST_STORE_MESSAGES_PENDING'});
  return irelandApi.post('/api/messages', {message})
    .then(() => {
      dispatch({type: 'POST_STORE_MESSAGES_PENDING'});
      toast.success(<ToastMessage iconStyle="success" message={'Message has been successfully sent'}/>);
    })
    .catch((error) => {
      dispatch({type: 'POST_STORE_MESSAGES_REJECTED'});

      toast.error(<ToastMessage iconStyle="error" message={'An error occurred during send message'}/>);
      return Promise.reject(error.response.data);
    });
};




// WEBPACK FOOTER //
// ./src/actions/messages.js